import classNames from 'classnames/bind';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { PrimaryButton } from '../../../components';
import styles from './OmossTextContent.module.scss';

let cx = classNames.bind(styles);

// Helper to get optimized image source
const getOptimizedImageSrc = (imageNode) => {
  if (!imageNode) return null;
  
  const sizes = imageNode.mediaDetails?.sizes || [];
  
  // Look for large (1024px) or medium_large (768px) size
  const large = sizes.find(size => size.name === 'large');
  const mediumLarge = sizes.find(size => size.name === 'medium_large');
  const medium = sizes.find(size => size.name === 'medium');
  
  // Return the best available size, fallback to full size
  return large?.sourceUrl || mediumLarge?.sourceUrl || medium?.sourceUrl || 
         imageNode.mediaItemUrl || imageNode.sourceUrl;
};

export default function OmossTextContent({ data }) {
  if (!data) return null;
  
  const [isPlaying, setIsPlaying] = useState(false);

  // Function to handle video click
  const handleVideoClick = () => {
    setIsPlaying(true);
  };

  // Function to get YouTube URL with parameters
  const getYouTubeUrl = () => {
    let url = data.linkToVideo || '';
    // Base parameters to always hide controls initially
    const baseParams = 'controls=0&modestbranding=1&rel=0&showinfo=0';
    
    // Add base parameters
    url += (url.includes('?') ? '&' : '?') + baseParams;
    
    // Add autoplay and show controls when playing
    if (isPlaying) {
      url += '&autoplay=1&controls=1';
    }
    
    return url;
  };

  return (
    <section className={cx('textContentSection')}>
      <div className={cx('container')}>
        {data.linkToVideo && (
          <div className={cx('videoWrapper', { playing: isPlaying })} onClick={handleVideoClick}>
            {!isPlaying && (
              <div className={cx('thumbnailOverlay')}>
                <Image
                  src="https://mediaboosterhe.wpenginepowered.com/wp-content/uploads/2025/05/MB-kontorbilder-15-scaled.jpg"
                  alt="Video thumbnail"
                  fill
                  style={{ objectFit: 'cover' }}
                  priority
                />
              </div>
            )}
            <iframe
              src={getYouTubeUrl()}
              title="Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
        <div className={cx('contentWrapper')}>
          <div className={cx('leftColumn')}>
            <h2>{data.header}</h2>
            <p>{data.textLeft}</p>
            {data?.button && (
              <div className={cx('primaryButtonWrapper')}>
                <PrimaryButton
                  href="/kontakt"
                  text={data.button.buttonText}
                  external={false}
                />
              </div>
            )}
          </div>
          <div className={cx('rightColumn')}>
            {data.image?.node && (
              <div className={cx('imageWrapper')}>
                <Image
                  src={getOptimizedImageSrc(data.image.node)}
                  alt={data.image.node.altText || ''}
                  width={1200}
                  height={675}
                  className={cx('image')}
                  quality={85}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 600px"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
} 